module.exports = __webpack_public_path__ + "img/professionalRefurbishment@2x.4faff19.jpg";